module.exports = __webpack_public_path__ + "/img/Header-Female-Right-Angle-Labeled-REuL27.svg";